module.exports = __webpack_public_path__ + "fonts/Inter-600-greek-ext59.2d64d8a.woff2";